import { useEffect, useRef } from 'react';
import { useLock } from '../context/LockContext';

const THROTTLE_MS = 1000; // الحد الأدنى بين تحديثات حركة المستخدم

/**
 * useIdleLock — نسخة تشخيصية مؤقتة (فيها console.log)
 * بعد ما نتأكد إنها تشتغل صح، نرجع نشيل الـ logs.
 */
export const useIdleLock = ({ idleLimitMs = 5 * 60 * 1000, enabled = true } = {}) => {
    const { lock, isLocked } = useLock();
    const timerRef = useRef(null);
    const lastResetRef = useRef(0);

    console.log('🟡 useIdleLock RENDER — enabled:', enabled, 'idleLimitMs:', idleLimitMs, 'isLocked:', isLocked);

    useEffect(() => {
        console.log('🟢 useIdleLock EFFECT شغّال — سيتم القفل بعد (مللي ثانية):', idleLimitMs);

        if (!enabled || !idleLimitMs) {
            console.log('🔴 الـ Effect توقف فوراً لأن enabled=false أو idleLimitMs=0');
            return;
        }

        const clearTimer = () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        };

        const resetTimer = () => {
            clearTimer();
            console.log('⏱️ تم إعادة ضبط المؤقت — القفل سيحصل الساعة:', new Date(Date.now() + idleLimitMs).toLocaleTimeString());
            timerRef.current = setTimeout(() => {
                console.log('🔒 انتهى الوقت — استدعاء lock() الآن!');
                lock();
            }, idleLimitMs);
        };

        const throttledResetTimer = () => {
            if (isLocked) return;
            const now = Date.now();
            if (now - lastResetRef.current >= THROTTLE_MS) {
                lastResetRef.current = now;
                resetTimer();
            }
        };

        const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
        events.forEach(evt => window.addEventListener(evt, throttledResetTimer, { passive: true }));

        resetTimer(); // التشغيل الابتدائي

        return () => {
            console.log('🧹 useIdleLock CLEANUP — تنظيف المؤقت والمستمعين');
            events.forEach(evt => window.removeEventListener(evt, throttledResetTimer));
            clearTimer();
        };
    }, [enabled, idleLimitMs, lock, isLocked]);
};